import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserHeart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7143 13.2857C8.29371 13.2857 6.14657 13.8326 4.73571 14.3083C3.69429 14.6606 3 15.642 3 16.7417V20.1428C3 20.1428 11.5354 20.1428 11.5714 20.1428",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7144 13.2857C8.34785 13.2857 6.42871 10.5094 6.42871 8.14286V7.28571C6.42871 4.91914 8.34785 3 10.7144 3C13.081 3 15.0001 4.91914 15.0001 7.28571V8.14286C15.0001 10.5094 13.081 13.2857 10.7144 13.2857Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.6801 14L18.8172 16.3042L21.3602 16.6736L19.5201 18.4672L19.9544 21L17.6801 19.8044L15.4058 21L15.84 18.4672L14 16.6736L16.5429 16.3042L17.6801 14Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUserHeart;
